module.exports = __webpack_public_path__ + "img/HOUSE_BALANCE.8f300c04.svg";